import { Steps } from '@noorden-insurtech/alba-design-system';

// Skeleton component customizado
function Skeleton({ className }: { className: string }) {
  return <div className={`bg-gray-200 animate-pulse rounded ${className}`} />;
}

export function NewQuoteFormSkeleton() {
  return (
    <div className='space-y-8'>
      <div className='md:hidden'>
        <Skeleton className='mb-3 h-4 w-24' />
        <div className='flex gap-3 overflow-hidden pb-2'>
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton key={index} className='h-10 w-16 shrink-0 rounded-full' />
          ))}
        </div>
        <Skeleton className='h-5 w-40' />
      </div>

      <div className='hidden md:block'>
        <Steps.Root step={0} count={5} linear>
          <Steps.List>
            {Array.from({ length: 5 }).map((_, index) => (
              <Steps.Item key={index} index={index}>
                <Steps.Trigger>
                  <Steps.Title>
                    <Skeleton className='h-4 w-24' />
                  </Steps.Title>
                </Steps.Trigger>
              </Steps.Item>
            ))}
          </Steps.List>
        </Steps.Root>
      </div>

      <div className='space-y-6 rounded-2xl bg-white p-4 shadow-md sm:p-8'>
        <Skeleton className='h-6 w-48' />

        <div className='space-y-4'>
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className='space-y-2'>
              <Skeleton className='h-4 w-32' />
              <Skeleton className='h-10 w-full' />
            </div>
          ))}
        </div>

        <div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className='space-y-2'>
              <Skeleton className='h-4 w-24' />
              <Skeleton className='h-10 w-full' />
            </div>
          ))}
        </div>

        <div className='mt-8 flex flex-col gap-3 sm:flex-row sm:justify-between'>
          <Skeleton className='h-10 w-full sm:w-24' />
          <Skeleton className='h-10 w-full sm:w-24' />
        </div>
      </div>
    </div>
  );
}
